/** @format */
// To do - To check with yash why we have add below line i.e require('process')
const process = require("process");

export const api = {
	apiUrl: "https://api.konfhub.com",
	graphQlUrl: "https://sponsor-api.konfhub.com/graphql",
	certhubAPIUrl: "https://certhub-api.konfhub.com",
	checkinAppUrl: "https://checkin-api.konfhub.com/graphql",
	getQuizzesApiUrl: "https://qh-api.konfhub.com",
	quizhubApiUrl: "https://quizhub-production-apim.azure-api.net",
	filesApiUrl: "https://files.konfhub.com"
};
